import { render, staticRenderFns } from "./ComponentTypePage.vue?vue&type=template&id=b0dc612a"
import script from "./ComponentTypePage.vue?vue&type=script&lang=js"
export * from "./ComponentTypePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports